<ion-header class="ion-no-border ion-header-modal-desktop">
  <ion-toolbar>
    <ion-buttons slot="end">
      <ion-button data-cy="close-modal-btn" (click)="dismissModal()">
        <ion-icon slot="icon-only" name="close-outline"></ion-icon>
      </ion-button>
    </ion-buttons>
    <ion-label>
      {{ 'i18n.common.sortBy' | translate }}
    </ion-label>
  </ion-toolbar>
</ion-header>

<ion-content class="ion-content-modal-desktop">
  <form
    [formGroup]="filtersFormGroup"
    data-cy="filter-desktop-form"
    (ngSubmit)="apply()"
    (keydown.enter)="apply()"
  >
    <ion-list formGroupName="sortOptions">
      <ion-radio-group
        data-cy="filter-desktop-radio-group"
        formControlName="sortOption"
      >
        <ion-item-divider></ion-item-divider>
        <ion-item
          *ngFor="
            let sortOption of searchViewModel?.searchResponse?.sortOptions
          "
        >
          <ion-label
            [attr.data-cy]="'filter-desktop-' + sortOption?.label + '-label'"
            >{{ sortOption?.label }}</ion-label
          >
          <ion-radio
            mode="md"
            [attr.data-cy]="
              'filter-desktop-' + sortOption?.label + '-radio-value'
            "
            slot="end"
            value="{{ sortOption.navigationState }}"
          ></ion-radio>
        </ion-item>
      </ion-radio-group>
    </ion-list>
  </form>
</ion-content>

<ion-footer class="ion-footer-modal ion-footer-modal-desktop">
  <ion-toolbar>
    <ion-buttons>
      <ion-button
        id="apply-modal-btn"
        data-cy="filter-desktop-button-apply"
        class="usf-fill-green-dsktp-tblt-modal-button"
        (click)="apply()"
      >
        {{ 'i18n.common.apply' | translate }}
      </ion-button>
    </ion-buttons>
  </ion-toolbar>
</ion-footer>
